export const cashoutModule = {
  state: {
    cashoutBets: {},
    cashoutDbSetting: false,
  },
  mutations: {
    addCashoutBets(state, payload) {
      const cashoutBets = payload.filter(b => b.CashoutValue);
      state.cashoutBets = Object.assign({}, ...cashoutBets.map(item => (
        { [item.BetSlipGroupID]: item }
      )));
    },
    changeCashoutDbSetting(state, payload) {
      state.cashoutDbSetting = payload;
    },
  },
  actions: {
    setCashoutDbSetting({ commit }, data) {
      commit("changeCashoutDbSetting", data);
    },
  },
  getters: {
    cashoutBetsCount(state) {
      return state.cashoutBets.length;
    },
    getCashoutByBetslipGroupId(state) {
      return (id) => {
        if (typeof state.cashoutBets[id] !== 'undefined') {
          return state.cashoutBets[id].CashoutValue;
        }
        return 0;
      };
    },
    getCashoutDbSetting(state) {
      return state.cashoutDbSetting;
    },
  },
};
